<script setup lang="ts">
import type { UserAvatarEntity, UserAvatarInitialsUi } from '#layers/access/types/user-avatar';
import type { GlobalFileId } from '#layers/data-model/public';
import { computed, ref, watch } from 'vue';
import { useSystemAssetUrl } from '#layers/assets/public';
import UserAvatarInitials from './UserAvatarInitials.vue';

const { user } = defineProps<{
	user: UserAvatarEntity;
	ui?: UserAvatarInitialsUi;
}>();

const avatarId = computed<GlobalFileId | null>(() => 'avatarId' in user ? user.avatarId ?? null : null);
const imageAlt = computed(() => user.fullName ?? ('email' in user ? user.email : '') ?? '');
const avatarUrl = useSystemAssetUrl(avatarId);
const hasError = ref(false);

watch(avatarId, () => {
	hasError.value = false;
});
</script>

<template>
	<span class="relative inline-block overflow-hidden rounded-full">
		<img
			v-if="avatarUrl && !hasError"
			:src="avatarUrl"
			:alt="imageAlt"
			class="size-full object-cover"
			@load="hasError = false"
			@error="hasError = true"
		>
		<UserAvatarInitials v-else :user :ui />
	</span>
</template>
